export default {
	type: 'object',
	properties: {
		projectUrl: { type: 'string' },
		recordId: { type: 'string' },
	},
	required: [],
	additionalProperties: false,
}
